import Grid from '@mui/material/Grid'

import NewDialog from './dialog/NewDialog'

const RightsDialog = () => (
    <NewDialog title="Welcome to Mockingbird!" onClose={() => {}}>
        <Grid container spacing={2}>
            <p>
                Nice of you to swing by! In order to make sure everything works perfectly the first
                time you log in we will need to connect your access rights manually.
            </p>
            <p>Please contact your Mockingbird Support.</p>
            <p>Best regards, The Mockingbird Team</p>
        </Grid>
    </NewDialog>
)

export default RightsDialog
